module.exports = __webpack_public_path__ + "static/media/materialdesignicons-webfont.63d2a595.woff";